<template>
	<div style="display: flex; flex-direction: column; height: 50px; line-height: 20px">
		<span>{{ label }}</span>
		<skySelect
		    ref="select"
			style="width: 150px"
			size="mini"
			:placeholder="placeholder"
			:options="options"
			v-model="type"
			@change="change"
		></skySelect>
	</div>
</template>

<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
export default {
	props: ['bind', 'label', 'placeholder'],

	data() {
		return {
			// placeholder: '请选择类型',
			options: [
				{
					label: '前缀',
					value: 1,
				},
				{
					label: '后缀',
					value: 2,
				},
				{
					label: '前缀+后缀',
					value: 3,
				},
			],
			type: null,
		};
	},

	components: { skySelect },

	computed: {},

	methods: {
		change(val) {
			this.$emit('valueChanged', val);
			
		},
	},
};
</script>

<style lang="scss" scoped></style>
